/* @ngInject */

export default () => {
  return {
    restrict: 'E',
    scope: {
      file: '='
    },
    link: function (scope, element) {
      element.prop('src', scope.file);
      $(element).audioPlayer();
    }
  };
};
